import Admin from './ScholarshipAdmin'
import User from './ScholarshipUser'

export default { Admin, User }
